import '../antdRender';
import { ConfigProvider, ThemeConfig } from 'antd';
import React from 'react';

export const withTheme = ({ children, theme }: { children: React.ReactNode, theme: ThemeConfig }) => {
  return (
    <ConfigProvider empty={{ className: 'empty-table' }} theme={theme}>
      {children}
    </ConfigProvider>
  )
};